/** Canonical Encapsulation station name in Postgres (`labor.device_session.page`). */
export const ENCAPSULATION_LABOR_PAGE = "encapsulation";

export const ENCAPSULATION_ACTIVITIES = ["potting", "conformal-coat"] as const;

export type EncapsulationActivity = (typeof ENCAPSULATION_ACTIVITIES)[number];

export function isEncapsulationActivity(value: string): value is EncapsulationActivity {
  return value === "potting" || value === "conformal-coat";
}

/** Wire page for lockdown and `labor.device_session` job context. Stored as page `encapsulation` plus `job_key`. */
export function encapsulationLaborPageKey(activity: EncapsulationActivity): string {
  return `encapsulation-job:${activity}`;
}

export function encapsulationActivityFromLaborPageKey(pageKey: string): EncapsulationActivity | null {
  const trimmed = pageKey.trim().toLowerCase();
  if (trimmed === "encapsulation-job:potting") return "potting";
  if (trimmed === "encapsulation-job:conformal-coat") return "conformal-coat";
  return null;
}

export function isEncapsulationLaborPageKey(pageKey: string): boolean {
  const trimmed = pageKey.trim().toLowerCase();
  return trimmed === ENCAPSULATION_LABOR_PAGE || trimmed.startsWith("encapsulation-job:");
}

export function encapsulationActivityLabel(activity: EncapsulationActivity): string {
  return activity === "potting" ? "Potting" : "Conformal coat";
}
